import { Injectable } from '@angular/core';
import { LocalStorageEnums } from './localStorageEnums';
import { BehaviorSubject } from 'rxjs';
import { ConferenceInfo } from 'src/app/layout/components/session-view/session-view.interface';
import { CryptoService } from '../crypto/crypto.service';

@Injectable(
  {providedIn: 'root'}
)
export class LocalStorageService {

  conferenceInfoSubject = new BehaviorSubject<ConferenceInfo | null>(null);

  constructor(
    private cryptoService: CryptoService,
  ) {}

  clear() {
    localStorage.clear();
  }

  getUserToken() {
    return localStorage.getItem('token');
  }

  getUserDetails() {
    return localStorage.getItem('userDetails');
  }

  setUserDetails(userInfo: any) {
    return localStorage.setItem(LocalStorageEnums.userInfo, JSON.stringify(userInfo));
  }

  setLoginInfo(loginInfo: any) {
    return localStorage.setItem(LocalStorageEnums.loginInfo, JSON.stringify(loginInfo));
  }

  getLoginInfo() {
    const loginInfo = localStorage.getItem(LocalStorageEnums.loginInfo);
    return JSON.parse(loginInfo || '{}');
  }

  // tslint:disable-next-line:typedef
  getSessionId() {
    const userDetails = this.getUserToken();
    if (userDetails) {
      return userDetails;
    }
    return false;
  }

  get(key: string) {
    const encryptedValue = localStorage.getItem(key);
    return (
      encryptedValue &&
      JSON.parse(this.cryptoService.decryptValue(encryptedValue))
    );
  }

  set<T>(key: string, value: T) {
    const encryptedValue = this.cryptoService.encryptValue(
      JSON.stringify(value),
    );
    localStorage.setItem(key, encryptedValue);
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

}
